import { useEffect, useState, useRef, useLayoutEffect, useCallback } from 'react'
import { debounce } from 'lodash'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover'
import { PageLink, PageTitle } from '../../_metronic/layout/core'
import { getDailyMpesaTransactions, getDailySales } from '../apis/Loadalltabledata'
import { KTCard } from '../../_metronic/helpers'
import { KTCardBody } from '../../_metronic/helpers'
import { KTSVG, toAbsoluteUrl } from '../../_metronic/helpers'
import { Maintable } from '../tables/Maintable'
import { useMemo } from 'react'
import LoadingBar from 'react-top-loading-bar'

import { useWindowWidth } from '@react-hook/window-size/throttled'
import {
  useMpesaTransactions2,
  useMpesaTransactions,
  useMpesaBalances,

} from '../contextProviders/Atomqueryprovider'
import CountUp from 'react-countup'
import '../css/popover.css'
import { Column } from 'react-table'
import { useAuth } from '../../app/modules/auth'
import { ItemsSummary } from '../topdashboard/ItemsSummary'
import { useMutation, useQueryClient } from 'react-query'
import io from 'socket.io-client'
import { useDashboard } from '../contextProviders/Dashboardcontext'
import useAggregatedData from '../helpers/useAggregatedData'
import useDataTrend from '../helpers/useDataTrend'
import { Mpesastk } from './modals/Mpesastk'
import { MpesastkCallback } from './modals/MpesastkCallback'
import { Mpesatransactionquery } from './modals/Mpesatransactionquery'
import { MpesastkCallbackStatus } from './modals/MpesastkCallbackStatus'
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import calendar from 'dayjs/plugin/calendar'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime)
dayjs.extend(calendar)
dayjs.extend(localizedFormat)
dayjs.extend(isBetween);



const CURRENCY_APP = process.env.REACT_APP_CURRENCY
const OPENING_TIME = process.env.REACT_APP_OPENING_TIME
const PIC_QUANTITIES = process.env.REACT_APP_QUANTITIES_PICS
// Hook

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dashboard',
    path: '/home',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]



const addCommas = (num: any) => {
  // Handle undefined, null, or non-numeric values
  if (num === undefined || num === null || num === '') {
    return '0'
  }
  
  // Convert to number if it's a string
  const numValue = typeof num === 'string' ? parseFloat(num) : num
  
  // Check if it's a valid number
  if (isNaN(numValue)) {
    return '0'
  }
  
  return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
const socket = io('possocket.27mirrors.com')
const truncate = require('truncate')
const isNegative = (num: any) => Math.sign(num) === -1

const Transactionmpesa = () => {
  const myRefmpesa: any = useRef()
  const myRefmpesatransaction: any = useRef()
  const refloadingbar: any = useRef(null)
  const queryClient = useQueryClient()
  const myRefsearch: any = useRef()
  const { currentUser, logout } = useAuth()
  const [paginationsize, setPaginationsize] = useState<number>(10)
  const [startlimit, setStartlimit] = useState<number>(0)
  const [statusnow, setStatusnow] = useState<boolean>(false)
  const [statusnow2, setStatusnow2] = useState<boolean>(false)
  const [itemto_order, setItemto_order] = useState<string>('transaction_time_now')
  const [desorasc, setDesorasc] = useState<string>('DESC')
  const [serversort, setServersort] = useState<any>([])
  const [search_item, setSearch_item] = useState<string>('%')
  const [pageCount, setPageCount] = useState<number>(0)
  const [mpesabalance, setMpesaBalance] = useState<number>(0)
  const [modalshowstk, setModalshowstk] = useState(false)
  const [modalshowtransquery, setModalshowtransquery] = useState(false)
  const [sumtransactionsdatanew, setSumtransactionsdatanew] = useState<any>([])
  const [hiddencolumnsmade, setHiddencolumnsmade] = useState<any>(['date_end', 'mpesa_transactions_made'])
  const onlyWidth = useWindowWidth()
  const [movetofirstpage, setMovetofirstpage] = useState<boolean>(false)
  const [mpesacallback, setMpesacallback] = useState<any>({})
  const [mpesacallbackstatus, setMpesacallbackstatus] = useState<any>({})
  const { showDashboard, toggleDashboard } = useDashboard();
  const [modalshowmpesastk, setModalshowmpesastk] = useState(false)
  const [modalshowmpesastatus, setModalshowmpesastatus] = useState(false)

  const credit: any = useAggregatedData(
    sumtransactionsdatanew
      .sort((a: any, b: any) => (a.transaction_time_now > b.transaction_time_now ? -1 : 1))
      .map((item: any) => ({
        transaction_time_now: item.transaction_time_now,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.received_amount,
      }))
  ).map((x: any) => x.totals_sum)
  const credit2: any = useAggregatedData(
    sumtransactionsdatanew
      .sort((a: any, b: any) => (a.transaction_time_now > b.transaction_time_now ? 1 : -1))
      .map((item: any) => ({
        transaction_time_now: item.transaction_time_now,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.received_amount,
      }))
  ).map((x: any) => x.totals_sum)

  const last_balance: any = useAggregatedData(
    sumtransactionsdatanew
      .sort((a: any, b: any) => (a.transaction_time_now > b.transaction_time_now ? -1 : 1))
      .map((item: any) => ({
        transaction_time_now: item.transaction_time_now,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.last_balance,
      }))
  ).map((x: any) => x.totals_sum)

  const last_balance2: any = useAggregatedData(
    sumtransactionsdatanew
      .sort((a: any, b: any) => (a.transaction_time_now > b.transaction_time_now ? 1 : -1))
      .map((item: any) => ({
        transaction_time_now: item.transaction_time_now,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.last_balance,
      }))
  ).map((x: any) => x.totals_sum)

  const last_balance_date: any = useAggregatedData(
    sumtransactionsdatanew
      .sort((a: any, b: any) => (a.transaction_time_now > b.transaction_time_now ? -1 : 1))
      .map((item: any) => ({
        transaction_time_now: item.transaction_time_now,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.last_balance,
      }))
  ).map((x: any) => x.month)

  const last_balance_date2: any = useAggregatedData(
    sumtransactionsdatanew
      .sort((a: any, b: any) => (a.transaction_time_now > b.transaction_time_now ? 1 : -1))
      .map((item: any) => ({
        transaction_time_now: item.transaction_time_now,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.last_balance,
      }))
  ).map((x: any) => x.month + ', ' + x.year)

  const credit_date: any = useAggregatedData(
    sumtransactionsdatanew
      .sort((a: any, b: any) => (a.transaction_time_now > b.transaction_time_now ? -1 : 1))
      .map((item: any) => ({
        transaction_time_now: item.transaction_time_now,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.received_amount,
      }))
  ).map((x: any) => x.month)

  const credit_date2: any = useAggregatedData(
    sumtransactionsdatanew
      .sort((a: any, b: any) => (a.transaction_time_now > b.transaction_time_now ? 1 : -1))
      .map((item: any) => ({
        transaction_time_now: item.transaction_time_now,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.received_amount,
      }))
  ).map((x: any) => x.month + ', ' + x.year)

  const debit: any = useAggregatedData(
    sumtransactionsdatanew
      .sort((a: any, b: any) => (a.transaction_time_now > b.transaction_time_now ? -1 : 1))
      .map((item: any) => ({
        transaction_time_now: item.transaction_time_now,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.withdrawn_amount,
      }))
  ).map((x: any) => x.totals_sum)

  const debit2: any = useAggregatedData(
    sumtransactionsdatanew
      .sort((a: any, b: any) => (a.transaction_time_now > b.transaction_time_now ? 1 : -1))
      .map((item: any) => ({
        transaction_time_now: item.transaction_time_now,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.withdrawn_amount,
      }))
  ).map((x: any) => x.totals_sum)

  const debit_date: any = useAggregatedData(
    sumtransactionsdatanew
      .sort((a: any, b: any) => (a.transaction_time_now > b.transaction_time_now ? -1 : 1))
      .map((item: any) => ({
        transaction_time_now: item.transaction_time_now,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.withdrawn_amount,
      }))
  ).map((x: any) => x.month)

  const debit_date2: any = useAggregatedData(
    sumtransactionsdatanew
      .sort((a: any, b: any) => (a.transaction_time_now > b.transaction_time_now ? 1 : -1))
      .map((item: any) => ({
        transaction_time_now: item.transaction_time_now,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.withdrawn_amount,
      }))
  ).map((x: any) => x.month + ', ' + x.year)


  const {
    isLoading: mpesabalancesloading,
    isSuccess: mpesabalancessuccess,
    data: mpesabalancesdata,
    status: mpesabalancesstatus,
    refetch: mpesabalancesrefetch,
    isRefetching: mpesabalancesisrefetching
  } = useMpesaBalances()

  socket.on('mpesa_balance_check', (amount: number) => {

    setMpesaBalance(amount);

  });

  socket.on('mpesa_call_back', (call_back: any) => {

    setModalshowmpesastk(true);

    setMpesacallback(call_back);
  });


  socket.on('mpesa_transaction_status', (call_back: any) => {

    setModalshowmpesastatus(true);

    setMpesacallbackstatus(call_back);
  });

  const {
    isLoading: dailympesaisloading,
    isSuccess: dailympesassuccess,
    data: dailympesadata,
    isPreviousData: dailympesaispreviousdata,
    isRefetching: dailympesarefetching,
    status: dailympesastatus,
    refetch: dailympesarefetch,
  } = useMpesaTransactions(
    new Date(dayjs
      .unix(dayjs(dayjs().startOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
      .format('YYYY-MM-DD hh:mm')),
    new Date(dayjs
      .unix(dayjs(dayjs().endOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
      .format('YYYY-MM-DD hh:mm')),
    startlimit,
    paginationsize,
    itemto_order,
    desorasc,
    search_item
  )


  const {
    isLoading: dailympesaisloading2,
    isSuccess: dailympesassuccess2,
    data: dailympesadata2,
    isPreviousData: dailympesaispreviousdata2,
    isRefetching: dailympesarefetching2,
    status: dailympesastatus2,
    refetch: dailympesarefetch2,
  } = useMpesaTransactions2(
    new Date(dayjs
      .unix(dayjs(dayjs().startOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
      .format('YYYY-MM-DD hh:mm')),
    new Date(dayjs
      .unix(dayjs(dayjs().endOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
      .format('YYYY-MM-DD hh:mm')),
    0,
    366,
    'transaction_time_now',
    'DESC',
    '%'
  )


  const tabledata = useMemo(
    () => dailympesadata?.data.dailympesatransactions,
    [dailympesadata?.data.dailympesatransactions, dailympesassuccess]
  )



  const tabledata3 = useMemo(
    () => dailympesadata2?.data.dailympesatransactions,
    [dailympesadata2?.data.dailympesatransactions, dailympesassuccess2]
  )

  const tabledatalength = useMemo(
    () => dailympesadata?.data.datalength,
    [dailympesadata?.data.datalength, dailympesassuccess]
  )

  const tablename = 'Transaction Summary'

  const filteredsubdata = (rowdata: any): number => {
    return rowdata.values.mpesa_transactions_made.length
  }

  const filteredtablesubData = (rowdata: any): any => {
    return rowdata.values.mpesa_transactions_made.sort((a: any, b: any) => (a.transaction_time > b.transaction_time ? -1 : 1))
  }

  const transactionsTrend = useDataTrend(tabledata3)

  useEffect(() => {
    if (!dailympesarefetching2 && dailympesassuccess2) {
      if (
        dayjs(
          dayjs(
            dailympesadata2?.data.dailympesatransactions
              .sort((a: any, b: any) => (a.transaction_time_now > b.transaction_time_now ? -1 : 1))
              .map((x: any) => x.transaction_time_now)[0]
          ).format('YYYY-MM-DD')
        ).unix() === dayjs(dayjs().format('YYYY-MM-DD')).unix()
      ) {
        setSumtransactionsdatanew(dailympesadata2?.data.dailympesatransactions)
      } else {
        if (
          dayjs(
            dayjs(
              dailympesadata2?.data.dailympesatransactions
                .sort((a: any, b: any) => (a.transaction_time_now > b.transaction_time_now ? -1 : 1))
                .map((x: any) => x.transaction_time_now)[0]
            ).format('YYYY-MM-DD')
          ).unix() === dayjs(dayjs().subtract(1, 'days').format('YYYY-MM-DD')).unix() &&
          dayjs(dayjs().format('YYYY-MM-DD, h:mm:ss a')).unix() <=
          dayjs(dayjs().format('YYYY-MM-DD') + OPENING_TIME).unix()
        ) {
          setSumtransactionsdatanew(dailympesadata2?.data.dailympesatransactions)
        } else {
          const currentitemsobj2: any = {
            transaction_time_now: dayjs().format('YYYY-MM-DD'),
            date_start: dayjs().format('YYYY-MM-DD'),
            date_end: dayjs().format('YYYY-MM-DD'),
            occurrences: 0,
            hours_selling: 0,
            totals: 0,
            received_amount: 0,
            last_balance: 0,
            withdrawn_amount: 0

          }
          setSumtransactionsdatanew([...dailympesadata2?.data.dailympesatransactions, currentitemsobj2])
        }
      }
    }

  }, [dailympesarefetching2,
    dailympesassuccess2])

  useEffect(() => {
    if (
      dailympesassuccess2
    ) {
      setStatusnow(true)
    } else {
      setStatusnow(false)
    }
  }, [dailympesassuccess2])

  useEffect(() => {
    if (
      statusnow &&
      !dailympesarefetching2
    ) {
      setStatusnow2(true)
    } else {
      setStatusnow2(false)
    }
  }, [
    dailympesarefetching2
  ])



  useEffect(() => {
    if (!dailympesaispreviousdata) {
      ; (async () => {
        await refloadingbar.current?.continuousStart()
        queryClient.prefetchQuery(
          ['mpesatransactions', startlimit + paginationsize, paginationsize],
          () =>
            getDailyMpesaTransactions(
              new Date(dayjs
                .unix(dayjs(dayjs().startOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
                .format('YYYY-MM-DD hh:mm')),
              new Date(dayjs
                .unix(dayjs(dayjs().endOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
                .format('YYYY-MM-DD hh:mm')),
              startlimit + paginationsize,
              paginationsize,
              itemto_order,
              desorasc,
              search_item
            )
        )
      })().finally(refloadingbar.current.complete())
    }
  }, [
    dailympesaispreviousdata,
    startlimit,
    paginationsize,
    queryClient,
    itemto_order,
    desorasc,
    search_item,
  ])

  useEffect(() => {
    const fetchData = async () => {
      try {
        await refloadingbar.current?.continuousStart();
        await dailympesarefetch();
      } catch (error) {
        console.log(error)
      } finally {
        refloadingbar.current.complete();
      }
    };
    fetchData();
  }, [itemto_order, desorasc, search_item]);


  useEffect(() => {
    const handleValueChange = () => {
      if (myRefsearch.current.value === '' && myRefsearch.current === document.activeElement) {
        setSearch_item('%')
        setPaginationsize(10)
        setStartlimit(0)
        setMovetofirstpage(true)
        setItemto_order('transaction_time_now')
        setDesorasc('DESC')
      }
    }

    const refSearch = myRefsearch.current;
    if (refSearch) {
      refSearch.addEventListener('input', handleValueChange);
    }

    return () => {
      if (refSearch) {
        refSearch.removeEventListener('input', handleValueChange);
      }
    }
  }, []);

  useEffect(() => {
    if (serversort.length > 0) {
      setItemto_order(serversort.map((x: any) => x.id)[0])
      setDesorasc(serversort.map((x: any) => x.desc)[0] ? 'DESC' : 'ASC')
    } else {
      setItemto_order('transaction_time_now')
      setDesorasc('DESC')
    }
  }, [serversort])

  const handlesearchKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      const inputValue = event.target.value;
      if (inputValue) {
        setSearch_item(inputValue + '%');
      } else {
        setSearch_item('%');
      }
      setPaginationsize(10)
      setStartlimit(0)
      setMovetofirstpage(true)
      setItemto_order('transaction_time_now')
      setDesorasc('DESC')
    }
  };

  const handleinputs = (event: any) => {
    if (myRefsearch.current.value === '' || event.target.value === '') {
      setSearch_item('%')
      setPaginationsize(10)
      setStartlimit(0)
      setMovetofirstpage(true)
      setItemto_order('transaction_time_now')
      setDesorasc('DESC')
    }
  }



  const handlesearchKeyDown2 = (event: any) => {
    event.preventDefault();
    const inputValue = myRefsearch.current.value || event.target.value;

    if (inputValue) {
      setSearch_item(inputValue + '%');
    } else {
      setSearch_item('%');
    }

    setPaginationsize(10)
    setStartlimit(0)
    setMovetofirstpage(true)
    setItemto_order('transaction_time_now')
    setDesorasc('DESC')
  }


  const showModalmpesastk = (x: any) => {
    setModalshowstk(true)

    myRefmpesa.current.Resetmodalmpesavalues()
  }

  const showModalmpesatransaction = (x: any) => {
    setModalshowtransquery(true)

    myRefmpesatransaction.current.Resetmodalmpesavalues()
  }

  const columndata1: ReadonlyArray<
    Column<{
      transaction_time_now: string
      date_start: string
      date_end: string
      occurrences: number
      hours_selling: number
      received_amount: number
      last_balance: number
      mpesa_credit_trend: number
      mpesa_transactions_made: Array<number | string>
    }>
  > = [
      {
        Header: () => null,
        id: 'expander',

        Cell: ({ row }: any) => {
          return (
            <span {...row.getToggleRowExpandedProps()}>
              {row.isExpanded ? (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              ) : (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              )}
            </span>
          )
        },
      },
      {
        Header: 'mpesa_transactions_made',
        accessor: 'mpesa_transactions_made',

      },
      {
        Header: 'Date',
        accessor: 'date_start', // accessor is the "key" in the data

        Cell: ({ cell: { value }, row }) => {
          return (
            <div className='d-flex align-items-center'>
              <div className='symbol symbol-60px me-5'>
                <span className='svg-icon svg-icon-primary svg-icon-3x'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='20'
                    height='21'
                    fill='none'
                    viewBox='0 0 20 21'
                  >
                    <path
                      fill='currentColor'
                      d='M19 3.4c-.6 0-1 .4-1 1v4h-4v-4c0-.6-.4-1-1-1s-1 .4-1 1v4H8v-4c0-.6-.4-1-1-1s-1 .4-1 1v4H2v-4c0-.6-.4-1-1-1s-1 .4-1 1v15c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-15c0-.6-.4-1-1-1zm-1 7v3h-4v-3h4zm-6 0v3H8v-3h4zm0 5v3H8v-3h4zm-6-5v3H2v-3h4zm-4 5h4v3H2v-3zm12 3v-3h4v3h-4z'
                      opacity='0.3'
                    ></path>
                    <path
                      fill='currentColor'
                      d='M19 .4H1c-.6 0-1 .4-1 1v3c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-3c0-.6-.4-1-1-1z'
                    ></path>
                  </svg>
                </span>
              </div>

              <div className='d-flex justify-content-start flex-column'>
                <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
                  {dayjs(value).format('MMMM')} {dayjs(value).format('DD')} -{' '}
                  {dayjs(row.original.date_end).format('DD')} , {dayjs(value).format('YYYY')}
                </span>
                <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
                  {dayjs(value).format('LTS')} - {dayjs(row.original.date_end).format('LTS')}
                </span>
              </div>
            </div>
          )
        },
      },

      {
        Header: 'Dates',
        accessor: 'date_end',

        Cell: ({ cell: { value } }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              {dayjs(value).format('LL')}
            </span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              {dayjs(value).format('dddd')}, {dayjs(value).format('LTS')}
            </span>
          </>
        ),
      },

      {
        Header: 'Entries',
        accessor: 'occurrences',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>{value}</span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              {row.original.hours_selling} Hours
            </span>
          </>
        ),
      },

      {
        Header: 'Balance',
        accessor: 'last_balance',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              <>
                {isNegative(value) ? (
                  <span className='text-danger'>
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}
                  </span>
                ) : (
                  <span>
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}{' '}
                  </span>
                )}
              </>
            </span>
            <span className='text-nowrap fw-bold text-muted d-block fs-7'>
              <span className='badge badge-light-danger'>

              </span>
            </span>
          </>
        ),
      },
      {
        Header: 'credit',
        accessor: 'received_amount',

        Cell: ({ cell: { value }, row }) => (
          <>
            {isNegative(value) ? (
              <span className='text-nowrap'>
                {isNegative(row.original.mpesa_credit_trend) ? (
                  <i className='fa fa-arrow-down text-danger'></i>
                ) : row.original.mpesa_credit_trend === 0 ? (
                  <i className='fa fa-arrow-up text-primary'></i>
                ) : (
                  <i className='fa fa-arrow-up text-success'></i>
                )}{' '}
                <span className='badge badge-light-danger'>
                  <span className='text-nowrap fs-7'>
                    {' '}
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}
                  </span>
                </span>
              </span>
            ) : (
              <span className='text-nowrap'>
                {isNegative(row.original.mpesa_credit_trend) ? (
                  <i className='fa fa-arrow-down text-danger'></i>
                ) : row.original.mpesa_credit_trend === 0 ? (
                  <i className='fa fa-arrow-up text-primary'></i>
                ) : (
                  <i className='fa fa-arrow-up text-success'></i>
                )}{' '}
                <span className='badge badge-light-success'>
                  <span className='text-nowrap fs-7'>
                    {' '}
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}
                  </span>
                </span>
              </span>
            )}
          </>
        ),
      },
    ]
  const columndata2: ReadonlyArray<
    Column<{
      transaction_type: string
      transaction_id: string
      transaction_time: string
      transaction_amount: number
      business_short_code: number
      bill_reference_number: number
      invoice_number: number
      org_account_balance: number
      third_party_transaction_id: string
      msisdn: string
      first_name: string
    }>
  > = [
      {
        Header: 'id',
        accessor: 'transaction_id',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>{value}</span>

          </>
        ),
      },
      {
        Header: 'type',
        accessor: 'transaction_type',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-primary text-nowrap  fw-bolder d-block mb-1 fs-6'>
              {truncate(value, 20)}
            </span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              TILL NO: {row.original.business_short_code}
            </span>

          </>
        ),
      },

      {
        Header: 'time',
        accessor: 'transaction_time',

        Cell: ({ cell: { value } }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              {dayjs(value).format('LL')}
            </span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              {dayjs(value).format('dddd')}, {dayjs(value).format('LTS')}
            </span>
          </>
        ),
      },

      {
        Header: 'amount',
        accessor: 'transaction_amount',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>
              {addCommas(value.toFixed(2))} {CURRENCY_APP}
            </span>

            <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
              Bal: {addCommas(row.original.org_account_balance.toFixed(2))} {CURRENCY_APP}
            </span>
          </>
        ),
      },
      {
        Header: 'msisdn',
        accessor: 'msisdn',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-success text-nowrap  fw-bolder d-block mb-1 fs-6'>
              {truncate(value,20)}
            </span>
            <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
              Name: {row.original.first_name}
            </span>
          </>
        ),
      },
    ]

  // less than 420

  const columndata3: ReadonlyArray<
    Column<{
      transaction_time_now: string
      date_start: string
      date_end: string
      occurrences: number
      hours_selling: number
      received_amount: number
      last_balance: number
      mpesa_credit_trend: number
      mpesa_transactions_made: Array<number | string>
    }>
  > = [
      {
        Header: () => null,
        id: 'expander',

        Cell: ({ row }: any) => {
          return (
            <span {...row.getToggleRowExpandedProps()}>
              {row.isExpanded ? (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              ) : (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              )}
            </span>
          )
        },
      },
      {
        Header: 'mpesa_transactions_made',
        accessor: 'mpesa_transactions_made',

      },
      {
        Header: 'Date',
        accessor: 'date_start', // accessor is the "key" in the data

        Cell: ({ cell: { value }, row }) => {
          return (
            <div className='d-flex align-items-center'>
              <div className='d-flex justify-content-start flex-column'>
                <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
                  {dayjs(value).format('MMM')} {dayjs(value).format('DD')} -{' '}
                  {dayjs(row.original.date_end).format('DD')} , {dayjs(value).format('YYYY')}
                </span>
                <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
                  {dayjs(value).format('LT')} - {dayjs(row.original.date_end).format('LT')}
                </span>
              </div>
            </div>
          )
        },
      },
      {
        Header: 'Dates',
        accessor: 'date_end',

        Cell: ({ cell: { value } }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              {dayjs(value).format('LL')}
            </span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              {dayjs(value).format('dddd')}, {dayjs(value).format('LTS')}
            </span>
          </>
        ),
      },

      {
        Header: 'credit',
        accessor: 'received_amount',

        Cell: ({ cell: { value }, row }) => (
          <>
            {isNegative(value) ? (
              <span className='text-nowrap'>
                {isNegative(row.original.mpesa_credit_trend) ? (
                  <i className='fa fa-arrow-down text-danger'></i>
                ) : row.original.mpesa_credit_trend === 0 ? (
                  <i className='fa fa-arrow-up text-primary'></i>
                ) : (
                  <i className='fa fa-arrow-up text-success'></i>
                )}{' '}
                <span className='badge badge-light-danger'>
                  <span className='text-nowrap fs-7'>
                    {' '}
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}
                  </span>
                </span>
              </span>
            ) : (
              <span className='text-nowrap'>
                {isNegative(row.original.mpesa_credit_trend) ? (
                  <i className='fa fa-arrow-down text-danger'></i>
                ) : row.original.mpesa_credit_trend === 0 ? (
                  <i className='fa fa-arrow-up text-primary'></i>
                ) : (
                  <i className='fa fa-arrow-up text-success'></i>
                )}{' '}
                <span className='badge badge-light-success'>
                  <span className='text-nowrap fs-7'>
                    {' '}
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}
                  </span>
                </span>
              </span>
            )}
          </>
        ),
      },
    ]

  const columndata4: ReadonlyArray<
    Column<{
      transaction_type: string
      transaction_id: string
      transaction_time: string
      transaction_amount: number
      business_short_code: number
      bill_reference_number: number
      invoice_number: number
      org_account_balance: number
      third_party_transaction_id: string
      msisdn: string
      first_name: string
    }>
  > = [
      {
        Header: 'id',
        accessor: 'transaction_id',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>{value}</span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              Name: {row.original.first_name} <span className='h-20px border-gray-200 border-start mx-2'></span>
              Phone: {row.original.msisdn}
            </span>

            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              Trans. Amount: {addCommas(row.original.transaction_amount.toFixed(2))} {CURRENCY_APP}
            </span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              Bal: {addCommas(row.original.org_account_balance.toFixed(2))} {CURRENCY_APP}
            </span>
            <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
              {dayjs(row.original.transaction_time).calendar()}
            </span>
          </>
        ),
      },

    ]

  //less than 420

  //less than 730 but more than 420
  const columndata5: ReadonlyArray<
    Column<{
      transaction_time_now: string
      date_start: string
      date_end: string
      occurrences: number
      hours_selling: number
      received_amount: number
      last_balance: number
      mpesa_credit_trend: number
      mpesa_transactions_made: Array<number | string>
    }>
  > = [
      {
        Header: () => null,
        id: 'expander',

        Cell: ({ row }: any) => {
          return (
            <span {...row.getToggleRowExpandedProps()}>
              {row.isExpanded ? (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              ) : (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              )}
            </span>
          )
        },
      },
      {
        Header: 'Date',
        accessor: 'date_start', // accessor is the "key" in the data

        Cell: ({ cell: { value }, row }) => {
          return (
            <div className='d-flex align-items-center'>
              <div className='symbol symbol-60px me-5'>
                <span className='svg-icon svg-icon-primary svg-icon-3x'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='20'
                    height='21'
                    fill='none'
                    viewBox='0 0 20 21'
                  >
                    <path
                      fill='currentColor'
                      d='M19 3.4c-.6 0-1 .4-1 1v4h-4v-4c0-.6-.4-1-1-1s-1 .4-1 1v4H8v-4c0-.6-.4-1-1-1s-1 .4-1 1v4H2v-4c0-.6-.4-1-1-1s-1 .4-1 1v15c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-15c0-.6-.4-1-1-1zm-1 7v3h-4v-3h4zm-6 0v3H8v-3h4zm0 5v3H8v-3h4zm-6-5v3H2v-3h4zm-4 5h4v3H2v-3zm12 3v-3h4v3h-4z'
                      opacity='0.3'
                    ></path>
                    <path
                      fill='currentColor'
                      d='M19 .4H1c-.6 0-1 .4-1 1v3c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-3c0-.6-.4-1-1-1z'
                    ></path>
                  </svg>
                </span>
              </div>

              <div className='d-flex justify-content-start flex-column'>
                <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
                  {dayjs(value).format('MMMM')} {dayjs(value).format('DD')} -{' '}
                  {dayjs(row.original.date_end).format('DD')} , {dayjs(value).format('YYYY')}
                </span>
                <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
                  {dayjs(value).format('LTS')} - {dayjs(row.original.date_end).format('LTS')}
                </span>
              </div>
            </div>
          )
        },
      },
      {
        Header: 'Dates',
        accessor: 'date_end',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              {dayjs(value).format('MMMM')} {dayjs(value).format('DD')} -{' '}
              {dayjs(row.original.date_end).format('DD')} , {dayjs(value).format('YYYY')}
            </span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              {dayjs(value).format('LTS')} - {dayjs(row.original.date_end).format('LTS')}
            </span>
          </>
        ),
      },
      {
        Header: 'mpesa_transactions_made',
        accessor: 'mpesa_transactions_made',

      },
      {
        Header: 'Entries',
        accessor: 'occurrences',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>{value}</span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              {row.original.hours_selling} Hours
            </span>
          </>
        ),
      },

      {
        Header: 'Balance',
        accessor: 'last_balance',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              <>
                {isNegative(value) ? (
                  <span className='text-danger'>
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}
                  </span>
                ) : (
                  <span>
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}{' '}
                  </span>
                )}
              </>
            </span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              <span className='badge badge-light-danger'>

              </span>
            </span>
          </>
        ),
      },
      {
        Header: 'credit',
        accessor: 'received_amount',

        Cell: ({ cell: { value }, row }) => (
          <>
            {isNegative(value) ? (
              <span className='text-nowrap'>
                {isNegative(row.original.mpesa_credit_trend) ? (
                  <i className='fa fa-arrow-down text-danger'></i>
                ) : row.original.mpesa_credit_trend === 0 ? (
                  <i className='fa fa-arrow-up text-primary'></i>
                ) : (
                  <i className='fa fa-arrow-up text-success'></i>
                )}{' '}
                <span className='badge badge-light-danger'>
                  <span className='text-nowrap fs-7'>
                    {' '}
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}
                  </span>
                </span>
              </span>
            ) : (
              <span className='text-nowrap'>
                {isNegative(row.original.mpesa_credit_trend) ? (
                  <i className='fa fa-arrow-down text-danger'></i>
                ) : row.original.mpesa_credit_trend === 0 ? (
                  <i className='fa fa-arrow-up text-primary'></i>
                ) : (
                  <i className='fa fa-arrow-up text-success'></i>
                )}{' '}
                <span className='badge badge-light-success'>
                  <span className='text-nowrap fs-7'>
                    {' '}
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}
                  </span>
                </span>
              </span>
            )}
          </>
        ),
      },
    ]
  const columndata6: ReadonlyArray<
    Column<{
      transaction_type: string
      transaction_id: string
      transaction_time: string
      transaction_amount: number
      business_short_code: number
      bill_reference_number: number
      invoice_number: number
      org_account_balance: number
      third_party_transaction_id: string
      msisdn: string
      first_name: string
    }>
  > =
    [
      {
        Header: 'id',
        accessor: 'transaction_id',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>{value}</span>


          </>
        ),
      },

      {
        Header: 'time',
        accessor: 'transaction_time',

        Cell: ({ cell: { value } }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              {dayjs(value).format('LL')}
            </span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              {dayjs(value).format('dddd')}, {dayjs(value).format('LTS')}
            </span>
          </>
        ),
      },

      {
        Header: 'amount',
        accessor: 'transaction_amount',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>
              {addCommas(value.toFixed(2))} {CURRENCY_APP}
            </span>

            <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
              Bal: {addCommas(row.original.org_account_balance.toFixed(2))} {CURRENCY_APP}
            </span>
          </>
        ),
      },
      {
        Header: 'msisdn',
        accessor: 'msisdn',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-success text-nowrap  fw-bolder d-block mb-1 fs-6'>
               {truncate(value,20)}
            </span>
            <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
              Name: {row.original.first_name}
            </span>
          </>
        ),
      },
    ]
  //less than 730 but more than 420

  return (
    <>
      <LoadingBar color='#009ef7' ref={refloadingbar} />
      <PageTitle breadcrumbs={usersBreadcrumbs}>Mpesa Transactions</PageTitle>
      {/* begin::Row */}
      {/* begin::Row */}
      {showDashboard && (
        <div className='row g-5 g-xl-8'>
          {/* begin::Col */}

          <div className='col-xl-4'>
            <ItemsSummary
              className='card-xl-stretch mb-xl-8'
              chartColor='primary'
              chartHeight='120px'
              cardName='Credit'
              chartName='Total Credits'
              statusnow={statusnow}
              statusnow2={statusnow2}
              yaxisHeight={
                Math.abs(Math.max(...credit))
              }
              chartCategories={credit_date2}
              chartData={credit2}
              values={
                <>
                  <div className='fs-2 fw-bolder d-block '>
                    <CountUp
                      className='text-primary'
                      end={credit[0]}
                      duration={2}
                      decimals={2}
                      separator=','
                    />{' '}
                    <sup className='fs-6 text-primary'>{CURRENCY_APP}</sup>
                  </div>
                </>
              }
              values2={
                <>
                  <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                    <table>
                      <tbody>
                        {credit[1] ? (
                          <tr>
                            <td>
                              <span className='badge badge-light-primary'>
                                {credit_date[1]}
                              </span>
                            </td>
                            <td>
                              <span className='h-20px border-gray-200 border-start mx-2'></span>
                              <CountUp
                                className='text-bold text-muted'
                                end={credit[1]}
                                duration={2}
                                decimals={2}
                                separator=','
                              />{' '}
                              <sup className='text-muted'>{CURRENCY_APP}</sup>
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}

                        {credit[2] ? (
                          <tr>
                            <td>
                              <span className='badge badge-light-primary'>
                                {credit_date[2]}
                              </span>
                            </td>
                            <td>
                              <span className='h-20px border-gray-200 border-start mx-2'></span>
                              <CountUp
                                className='text-bold text-muted'
                                end={credit[2]}
                                duration={2}
                                decimals={2}
                                separator=','
                              />{' '}
                              <sup className='text-muted'>{CURRENCY_APP}</sup>
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}
                      </tbody>
                    </table>
                  </span>
                </>
              }
            />
          </div>
          {/* end::Col */}

          {/* begin::Col */}
          <div className='col-xl-4'>
            <ItemsSummary
              className='card-xl-stretch mb-xl-8'
              chartColor='danger'
              chartHeight='120px'
              cardName='Debit'
              chartName='Total Debits'
              statusnow={statusnow}
              statusnow2={statusnow2}
              yaxisHeight={
                Math.abs(Math.max(...debit))
              }
              chartCategories={debit_date2}
              chartData={debit2}
              values={
                <div className='fs-2 fw-bolder'>
                  <CountUp
                    className='text-danger'
                    end={debit[0]}
                    duration={2}
                    decimals={2}
                    separator=','
                  />{' '}
                  <sup className='text-danger fs-6'>{CURRENCY_APP}</sup>
                </div>
              }
              values2={
                <>
                  <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                    <table>
                      <tbody>
                        {debit[1] ? (
                          <tr>
                            <td>
                              <span className='badge badge-light-danger'>
                                {debit_date[1]}
                              </span>
                            </td>
                            <td>
                              <span className='h-20px border-gray-200 border-start mx-2'></span>
                              <CountUp
                                className='text-bold text-muted'
                                end={debit[1]}
                                duration={2}
                                decimals={2}
                                separator=','
                              />{' '}
                              <sup className='text-muted'>{CURRENCY_APP}</sup>
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}

                        {debit[2] ? (
                          <tr>
                            <td>
                              <span className='badge badge-light-danger'>
                                {debit_date[2]}
                              </span>
                            </td>
                            <td>
                              <span className='h-20px border-gray-200 border-start mx-2'></span>
                              <CountUp
                                className='text-bold text-muted'
                                end={debit[2]}
                                duration={2}
                                decimals={2}
                                separator=','
                              />{' '}
                              <sup className='text-muted'>{CURRENCY_APP}</sup>
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}
                      </tbody>
                    </table>
                  </span>
                </>
              }
            />
          </div>
          {/* end::Col */}

          {/* begin::Col */}
          <div className='col-xl-4'>
            <ItemsSummary
              className='card-xl-stretch mb-5 mb-xl-8'
              chartColor={'success'}
              chartHeight='120px'
              statusnow={statusnow}
              statusnow2={statusnow2}
              cardName={'Balance'}
              chartName={'Account Balance'}
              yaxisHeight={
                Math.abs(Number(Math.max(...last_balance).toFixed(0))) +
                Math.abs(Number(Math.min(...last_balance).toFixed(0)))
              }
              chartCategories={last_balance_date2}
              chartData={last_balance2}
              values={
                <>
                  <div className='fs-2 fw-bolder'>
                    <CountUp
                      className={'text-success'}
                      end={last_balance[0]}
                      duration={2}
                      decimals={2}
                      separator=','
                    />{' '}
                    <sup
                      className={`${isNegative(last_balance[0]) ? 'fs-6 text-danger' : 'fs-6 text-success'
                        }`}
                    >
                      {CURRENCY_APP}
                    </sup>
                  </div>
                </>
              }
              values2={
                <>
                  <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                    <table>
                      <tbody>
                        {last_balance[1] ? (
                          <tr>
                            <td>
                              <span
                                className={'badge badge-light-success'}
                              >
                                {last_balance_date[1]}
                              </span>
                            </td>
                            <td>
                              <span className='h-20px border-gray-200 border-start mx-2'></span>
                              <CountUp
                                className='text-bold text-muted'
                                end={last_balance[1]}
                                duration={2}
                                decimals={2}
                                separator=','
                              />{' '}
                              <sup className='text-muted'>{CURRENCY_APP}</sup>
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}

                        {last_balance[2] ? (
                          <tr>
                            <td>
                              <span
                                className={'badge badge-light-success'}
                              >
                                {last_balance_date[2]}
                              </span>
                            </td>
                            <td>
                              <span className='h-20px border-gray-200 border-start mx-2'></span>
                              <CountUp
                                className='text-bold text-muted'
                                end={last_balance[2]}
                                duration={2}
                                decimals={2}
                                separator=','
                              />{' '}
                              <sup className='text-muted'>{CURRENCY_APP}</sup>
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}
                      </tbody>
                    </table>
                  </span>
                </>
              }
            />
          </div>
          {/* end::Col */}
        </div>)}
      {/* end::Row */}

      <KTCard>
        <KTCardBody className='py-4'>
          <div className='row mt-4'>
            <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'>
              <div className='mb-2'>
                <h3 className='fw-bolder my-2'>Buy Goods Credits</h3>
              </div>
            </div>

            <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
              <div className='mb-2'>
                {/* begin::Search */}
                <div className='d-flex align-items-center position-relative my-1'>
                  <a href='#' onClick={handlesearchKeyDown2}>
                    <KTSVG
                      path='/media/icons/duotune/general/gen021.svg'
                      className='svg-icon-1 position-absolute me-4 top-0 end-0 mt-3 text-primary'

                    />
                  </a>
                  <input
                    type='text'
                    data-kt-user-table-filter='search'
                    className='form-control form-control-solid w-250px ps-14'
                    placeholder='Search Transactions'
                    ref={myRefsearch}
                    // value={searchTitle}
                    onChange={handleinputs}
                    onKeyDown={handlesearchKeyDown}


                  />
                </div>
                {/* end::Search */}
              </div>
            </div>
          </div>

          <div className='row mt-5 mb-5'>
            <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'></div>

            <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
              <div className='mb-2'>
                <div className='d-flex align-items-center text-nowrap'>
                  <span className='text-muted fw-bolder fs-7 text-uppercase gs-0'>INSIGHTS</span>
                  <span className='h-50px border-gray-200 border-start mx-2'></span>
                  <div className='d-flex justify-content-start flex-column'>
                    <span className='fw-bold d-block fs-7 text-muted'>
                      <table>
                        <tbody>

                          {dailympesassuccess2 ? (
                            <tr>
                              <td>C.AVERAGE</td>
                              <td>
                                <span className='h-20px border-gray-200 border-start mx-2'></span>
                                <span className='text-uppercase text-bolder'>
                                  <CountUp
                                    className='text-primary'
                                    end={
                                      Number(
                                        tabledata3.reduce(
                                          (acc: any, curr: any) => acc + curr.received_amount,
                                          0
                                        )
                                      ) / tabledata3.length
                                    }
                                    duration={2}
                                    decimals={2}
                                    separator=','
                                  />{' '}
                                  <sup> {CURRENCY_APP}</sup>
                                </span>
                              </td>
                            </tr>
                          ) : (
                            <></>
                          )}


                          <tr>
                            <td>C.BALANCE</td>
                            <td>
                              <span className='h-20px border-gray-200 border-start mx-2'></span>

                              <CountUp
                                className='text-dark'
                                end={mpesabalancessuccess ? mpesabalance : 0}
                                duration={2}
                                decimals={2}
                                separator=','
                              />{' '}
                              <sup> {CURRENCY_APP}</sup>

                            </td>
                          </tr>

                        </tbody>
                      </table>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-12 col-md-5 col-xxl-12 d-flex align-items-center justify-content-center justify-content-md-start'></div>

            <div className='col-sm-12 col-md-7 col-xxl-12 d-flex align-items-center justify-content-center justify-content-md-end'>
              <div className='mb-2'>
                {/* begin::Search */}
                <div className='col-sm-12 col-md-12 d-flex align-items-center justify-content-center justify-content-md-end'>
                  <div className='mb-2' style={{ display: 'inline-grid', gridTemplateColumns: '1fr 1fr' }}>
                    {/* buying buttons */}

                    <a
                      className='btn btn-info btn-sm me-2 mb-2 text-nowrap'
                      href='#'
                      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                        e.preventDefault();
                        showModalmpesatransaction(e);
                      }}
                      title={onlyWidth <= 576 ? 'M-Pesa Query' : ''}
                    >
                      <KTSVG
                        path='/media/icons/duotune/general/gen046.svg'
                        className='svg-icon-1'
                      />
                      {onlyWidth <= 576 ? 'Q' : 'M-Pesa Query'}
                    </a>

                    <a
                      className='btn btn-primary btn-sm mb-2 text-nowrap'
                      href='#'
                      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                        e.preventDefault();
                        showModalmpesastk(e);
                      }}
                      title={onlyWidth <= 576 ? 'STK Push' : ''}
                    >
                      <KTSVG
                        path='/media/icons/duotune/electronics/elc003.svg'
                        className='svg-icon-1'
                      />
                      {onlyWidth <= 576 ? 'STK' : 'STK Push'}
                    </a>

                    {/* buying buttons */}
                  </div>
                </div>
                {/* end::Search */}
              </div>
            </div>
          </div>


          <Maintable
            tabledata={dailympesassuccess ? tabledata : []}
            startlimit={startlimit}
            hiddencolumnsmade={hiddencolumnsmade}
            movetofirstpage={movetofirstpage}
            setMovetofirstpage={setMovetofirstpage}
            setstartlimit={setStartlimit}
            paginationsize={paginationsize}
            pageCount={pageCount}
            setPageCount={setPageCount}
            setPaginationsize={setPaginationsize}
            columndata={
              onlyWidth <= 576
                ? columndata3
                : onlyWidth > 576 && onlyWidth <= 768
                  ? columndata5
                  : columndata1
            }
            tabledata2={tabledata}
            columndata2={
              onlyWidth <= 576
                ? columndata4
                : onlyWidth > 576 && onlyWidth <= 768
                  ? columndata6
                  : columndata2
            }
            table1loaded={dailympesastatus === 'success'}
            table2loaded={dailympesastatus2 === 'success'}
            tablename={tablename}
            tablelength={dailympesastatus === 'success' && dailympesastatus2 === 'success' ? tabledatalength : 0}
            filteredsubdata={filteredsubdata}
            filteredtablesubData={filteredtablesubData}
            setServersort={setServersort}
          />
        </KTCardBody>
      </KTCard>

      <Mpesastk

        show={modalshowstk}
        ref={myRefmpesa}
        handleClose={function (): void {
          setModalshowstk(false)
        }}

      />


      <Mpesatransactionquery
        show={modalshowtransquery}
        ref={myRefmpesatransaction}
        handleClose={function (): void {
          setModalshowtransquery(false)
        }}
      />

      <MpesastkCallback
        show={modalshowmpesastk}
        mpesacallback={mpesacallback}
        handleClose={function (): void {
          setMpesacallback({})
          setModalshowmpesastk(false)
        }}
      />

      <MpesastkCallbackStatus
        show={modalshowmpesastatus}
        mpesacallbackstatus={mpesacallbackstatus}
        handleClose={function (): void {
          setMpesacallbackstatus({})
          setModalshowmpesastatus(false)
        }}


      />
    </>
  )
}

export default Transactionmpesa;


